import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  IrpfAscendantDto,
  IrpfDescendantDto,
  IrpfDto,
  IrpfIndividualDto,
  IrpfPatchedDto,
  IrpfPensionPaymentDto
} from '@app/data/dtos/ptrab/irpf/irpf.dto';
import { mapIrpf, mapPatchedIrpf } from '@app/data/mappers/ptrab/irpf/irpf.mappers';
import { IrpfRepository } from '@app/domain/repositories/ptrab/irpf/irpf.repository.contract';
import { IrpfSections } from '@app/entities/enums/ptrab/irpf.enum';
import { IDataObjectResponse } from '@app/entities/interfaces/data/data.interface';
import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { IrpfModel } from '@app/entities/models/ptrab/irpf/irpf.model';
import { ENV } from '@environments/environment';
import { SECTION_KEY } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class IrpfRepositoryImpl extends MRepository implements IrpfRepository {
  irpfUrl = '/ptrab/v2/personal-income-tax';

  constructor() {
    super(`${ENV.API_URL_PTRAB}`);
  }

  getData(): Observable<IrpfModel> {
    return this.get<IrpfDto>(this.irpfUrl, { context: new HttpContext().set(SECTION_KEY, 'irpf-data') }).pipe(
      map(mapIrpf)
    );
  }

  modifyIrpfData(
    params: IDataObjectResponse<
      IrpfIndividualDto | IrpfDescendantDto[] | IrpfAscendantDto[] | IrpfPensionPaymentDto | boolean,
      string
    >,
    section: IrpfSections,
    authorization?: TwoFactorAuthorization
  ): Observable<IrpfModel> {
    const request = {
      body: {
        ...params,
        authorization
      }
    };

    if (!authorization) {
      delete request.body.authorization;
    }

    return this.patch<IrpfPatchedDto>(`${this.irpfUrl}/${section}`, request).pipe(map(mapPatchedIrpf));
  }
}
